import React from "react";
import "./TabNavigation.scss";

interface TabNavigationProps {
  activeTab: "select" | "dispense";
  onTabChange: (tab: "select" | "dispense") => void;
}

const TabNavigation = ({ activeTab, onTabChange }: TabNavigationProps) => {
  return (
    <div className="tab-navigation">
      <div
        className={`tab left-tab ${activeTab === "select" ? "active" : ""}`}
        role="button"
        tabIndex={0}
        onClick={() => onTabChange("select")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onTabChange("select");
          }
        }}
      >
        <div className="tab-header">TOP VIEW</div>
        <div className="tab-content">1. Select the well(s)</div>
      </div>
      <div
        className={`tab right-tab  ${activeTab === "dispense" ? "active" : ""}`}
        role="button"
        tabIndex={0}
        onClick={() => onTabChange("dispense")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onTabChange("dispense");
          }
        }}
      >
        <div className="tab-header">SIDE VIEW</div>
        <div className="tab-content">2. Dispense the liquid</div>
      </div>
    </div>
  );
};

export default TabNavigation;
